/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState, useRef } from 'react'
import ApexCharts, { ApexOptions } from 'apexcharts'
import { getCSS, getCSSVariableValue } from '../../../../assets/ts/_utils'
import { useThemeMode } from '../../../layout/theme-mode/ThemeModeProvider'
import { useIntl } from "react-intl";
import { useAuth } from '../../../../../app/modules/auth'
import { getCurriculumActivityChart } from '../../../../../app/modules/curriculum/curricula-list/core/_requests'
import { ChartModel, initialChartModel } from '../../../../../_metronic/partials/widgets/charts/_models'
import { useYear } from '../../../../../_metronic/partials/layout/header-menus/YearsManager'
import { RoleModel } from '../../../../../app/modules/auth/core/_models'
import { useTerm } from '../../../layout/header-menus/TermsManager';

type Props = {
  className: string
  unitId?:number
  customerId?:number
}

const CurriculumActivityChart: React.FC<Props> = ({ className ,unitId = undefined , customerId = undefined}) => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  const { mode } = useThemeMode()
  const intl = useIntl();
  const { currentUser, auth } = useAuth()
  const currentYearId = useYear()
  const currentTermId = useTerm()

  useEffect(() => {
    let query = ''
    if (auth?.currentRole === RoleModel.Admin)
      query = "&academicYearId=" + currentYearId
    else if (auth?.currentRole === RoleModel.InstitutionManager)
      query = "&institutionId=" + currentUser?.institutionId + "&academicYearId=" + currentYearId
    else if (auth?.currentRole === RoleModel.Customer || auth?.currentRole === RoleModel.Person)
      query = "&customerId=" + currentUser?.customerId + "&academicYearId=" + currentYearId
    else
      query = "&institutionId=" + currentUser?.institutionId + "&subinstitutionId=" + currentUser?.subinstitutionId + "&academicYearId=" + currentYearId + "&termId=" + currentTermId + "&employeeId=" + currentUser?.employeeId + (unitId ? "&unitId=" + unitId:'') + (customerId ? "&customerId=" + customerId:'')
      getCurriculumActivityChart(query).then((value) => {
      setCurriculumActivityChart(value);
    })
  }, [className,unitId,customerId])

  const [curriculumActivtiyChart, setCurriculumActivityChart] = useState<ChartModel | undefined>(initialChartModel)
  const refreshMode = () => {
    if (!chartRef.current) {
      return
    }
    const height = parseInt(getCSS(chartRef.current, 'height'))
    const chart = new ApexCharts(chartRef.current, getChartOptions(height, curriculumActivtiyChart))

    if (chart) {
      chart.render()
    }

    return chart
  }

  useEffect(() => {
    const chart = refreshMode()

    return () => {
      if (chart) {
        chart.destroy()
      }
    }

  }, [chartRef, mode, curriculumActivtiyChart])

  function getChartOptions(height: number, curriculumActivtiyChart: ChartModel | undefined): ApexOptions {
    const labelColor = getCSSVariableValue('--kt-gray-500')
    const borderColor = getCSSVariableValue('--kt-gray-200')
    const baseColor = getCSSVariableValue('--kt-primary') 
    const secondaryColor = getCSSVariableValue('--kt-success')  

    return {
        series: [
            {
              data: curriculumActivtiyChart?.series1!.map((serie, index) => ({
                x: curriculumActivtiyChart?.categories![index], 
                y: (serie / 60).toFixed(2) 
              })) ?? [{ x: '', y: 0 }]
            }
          ],
      chart: {
        fontFamily: 'inherit',
        type: 'bar', 
        height: 380,
        toolbar: {
          show: true,
        },
      },
        
      plotOptions: {
        bar: {
          horizontal: true, 
          distributed: true,  
          barHeight: '100%',
          dataLabels: {
            position: 'bottom',
          },
        },
      },
      colors: [
        '#33b2df', '#546E7A', '#d4526e', '#13d8aa', '#A5978B', '#2b908f', '#f9a3a4', '#90ee7e',
        '#f48024', '#69d2e7',
      ],
      dataLabels: {
        enabled: true,
        textAnchor: 'start',
        style: {
          colors: ['#fff'],
        },
        formatter: function (val, opt) {
          return (
            (opt?.w?.globals?.labels?.[opt.dataPointIndex] || '') + ': ' + val
          )
        },
        offsetX: 0,
        dropShadow: {
          enabled: true,
        },
      },
      xaxis: {
        labels: {
          style: {
            colors: labelColor,
            fontSize: '12px',
          },
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
      },
      yaxis: {
        labels: {
          show: false,
        },
      },
      tooltip: {
        theme: 'dark',
        x: {
          show: false,
        },
        y: {
          title: {
            formatter: function () {
              return ''
            },
          },
        },
      },
      grid: {
        borderColor: borderColor,
        strokeDashArray: 4,
      },
    }
  }

  return (
    <div className={`card ${className}`}>
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>{intl.formatMessage({ id: '6lt' })}</span>
          <span className='text-muted fw-semibold fs-7'> {intl.formatMessage({ id: '6lu' })}</span>
        </h3>
      </div>
      <div className='card-body'>
        <div ref={chartRef} id='kt_charts_widget_3_chart' style={{ height: '350px' }}></div>
      </div>
    </div>
  )
}

export { CurriculumActivityChart}
